// extracted by mini-css-extract-plugin
export var childrenContainer = "_a7-0";